export const EXPLAIN_BUTTON_LABEL = 'Explain with AI';
export const EXPLAIN_INLINE_SCHEMA_DOMAIN = 'inline-expression';
export const EXPLAIN_MODAL_TITLE = 'AI explanation';
export const EXPLAIN_EMPTY_EXPRESSION_HELPER = 'Type an expression first to explain it.';
export const EXPLAIN_LOADING_HELPER = 'Reading the expression and reviewing the schema…';
export const EXPLAIN_ERROR_HELPER = 'Could not generate an explanation. Please try again.';
export const EXPLAIN_READS_LABEL = 'Reads';
export const EXPLAIN_WATCH_OUT_LABEL = 'Watch out';
